import styled from "@emotion/styled";
import { Spacer } from "../../../layout";
import { datePickerTheme } from "./datePickerTheme";
const shouldForwardProp = propName => propName !== "themeMode";
export const DatePickerFooter = styled(Spacer, {
  shouldForwardProp
})`
    justify-content: center;
    margin-top: ${_ref => {
  let {
    themeMode
  } = _ref;
  return datePickerTheme.footer.marginTop(themeMode);
}};
`;
//# sourceMappingURL=DatePickerFooter.js.map